import React, { useState } from "react"
import { Checkbox, CircularProgress, FormHelperText, IconButton } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import ListItemText from "@material-ui/core/ListItemText"
import { SearchIcon } from "@iconsGallery"
import { Button, OutlinedInput, FormControl } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import * as QA_Automation from "@qaAutomation"
import { Clear } from "@material-ui/icons"

const useStyle = makeStyles({
  disableTextHover: {
    "& .MuiListItem-button:hover": {
      background: "transparent !important",
    },
  },
  formControl: {
    width: "100%",
    "& .MuiFormLabel-root.Mui-focused": {
      color: "var(--primaryColor)",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "var(--primaryColor)",
      },
    },
  },
  menuCheckbox: {
    "& .MuiCheckbox-colorSecondary.Mui-disabled": {
      color: "gray !important",
    },
  },
  textInput: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--primaryColor)",
    },
  },
})

const DropdownPagination = (props) => {
  const {
    label = "",
    fetchData = () => "",
    data: dropdownData,
    filteredItem = {},
    handleDropdownChange = () => "",
    handleSearchTerm = () => {},
    totalDocs = "",
    handleShowMore = () => {},
    searchTerm = "",
    fullWidth = false,
    isLookup = true,
    placeholder = "",
    error,
    helperText,
    isShowFooter = true,
    isShowSearch = true,
    disableMenuName = "",
    widthProp = "30vh",
    heightProp = "36px",
    multiple = false,
  } = props || {}
  const classes = useStyle()
  const [loading, setLoading] = React.useState(false)
  const [selectedItems, setSelectedItems] = React.useState(filteredItem)

  const [searchText, setSearchText] = React.useState(searchTerm)

  let ref = React.useRef(null)

  const { t } = useTranslation()

  //console.log(selectedItems, "dropdownData[0]")
  // React.useEffect(() => {
  //   setSelectedItems(selectedItems)
  // }, [selectedItems])

  React.useEffect(() => {
    setSearchText(searchTerm)
  }, [searchTerm])

  React.useEffect(() => {
  if (ref.current) {
    ref.current.focus();
  }
}, [searchText]);

  React.useEffect(() => {
    setSelectedItems(filteredItem)
  }, [filteredItem])

  React.useEffect(() => {
    QA_Automation?.doAddOnTestIdCommonAutoCompleteDropdown(ref, props)
  }, [selectedItems, searchTerm, filteredItem])

  const ITEM_HEIGHT = 70
  const ITEM_PADDING_TOP = 5

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: () => null,
    anchorOrigin: { vertical: "bottom" },
  }

  const handleChange = (event) => {
        setSelectedItems(event.target.value)
        handleDropdownChange(event.target.value, label)
  }

  const handleSearch = (val) => {
    setLoading(true)
    setSearchText(val)
    setTimeout(() => {
      setLoading(false)
    }, 1000)
    handleSearchTerm(val, label)
  }

  return (
    <FormControl
      className={classes.formControl}
      fullWidth={fullWidth}
      style={{ maxWidth: widthProp, minWidth: "200px" }}
    >
      <Select
        multiple={multiple}
        value={selectedItems}
        onChange={(event) => {
          handleChange(event)
        }}
        defaultValue={multiple ? [] : "none"}
        placeholder={t(placeholder)}
        displayEmpty
        input={
          <OutlinedInput
            margin="dense"
            style={{ width: widthProp, height: "36px" }}
          />
        }
        renderValue={(selected) => {
          if (Array.isArray(selected)) {
            if (selected.length > 3) {
              return <b>{selected.slice(0, 3).map(item => item?.name).join(", ") + ", ..."}</b>
            }
            return <b>{selected.map(item => item?.name).join(", ") || t(label)}</b>
          }
          return <b>{t(selected?.name) || t(label)}</b>
        }}
        style={{
          backgroundColor: "transparent",
          height: heightProp,
          width: fullWidth ? "100%" : isLookup ? "20vh" : "100%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
        }}
        id="id-detailedTransactionReport-common"
        labelId="id-detailedTransactionReport-common"
        MenuProps={{
          ...MenuProps,
          classes: { paper: "cls-detailedTransactionReport-common-type" },
        }}
      >
        {isShowSearch && (
          <MenuItem
            value=""
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "5px 10px 10px 10px",
              backgroundColor: "#ffff",
              position: "sticky",
              top: "0px",
              zIndex: "1",
            }}
          >
            <TextField
              inputRef={ref}
              autoFocus
              variant="outlined"
              size="small"
              placeholder={t("SEARCH")}
              value={searchText}
              InputProps={{
                endAdornment: (
                  <IconButton size="small" onClick={() => handleSearch("")}>
                    {searchText ? (
                      <Clear style={{ color: "#CCC" }} />
                    ) : (
                      <SearchIcon style={{ color: "#CCC" }} />
                    )}
                  </IconButton>
                ),
              }}
              className={classes.textInput}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
              onChange={(event) => {
                handleSearch(event.target.value.replace(/(\s{2,})/g, " "))
              }}
            />
          </MenuItem>
        )}
        {loading ? (
          !isShowFooter && (
            <CircularProgress size={30} style={{ margin: "80px" }} />
          )
        ) : dropdownData !== undefined && dropdownData?.length > 0 ? (
          dropdownData.map((name, idx) => {
            const isChecked = Array.isArray(selectedItems)
              ? selectedItems.some((item) => item?.id === name.id)
              : selectedItems?.id === name.id
            return (
              <MenuItem
                key={name.id}
                value={name}
                style={{ height: "36px" }}
                disabled={name.name === disableMenuName}
                className={classes.menuCheckbox}
              >
                {multiple && (
                  <Checkbox
                    checked={isChecked}
                    color="primary"
                    style={{
                      padding: "0px 8px 0px 0px",
                      color: isChecked ? "var(--primaryColor)" : undefined,
                    }}
                  />
                )}
                <ListItemText primary={name.name} style={{ fontSize: "14px" }} />
              </MenuItem>
            )
          })
        ) : (
          <MenuItem disabled style={{ height: "30px" }}>
            {t("NO_ITEMS_FOUND")}
          </MenuItem>
        )}
        {isShowFooter && (
          <>
            {loading ? (
              <CircularProgress size={30} style={{ margin: "80px" }} />
            ) : totalDocs > dropdownData?.length > 0 ? (
              <MenuItem
                style={{ background: "transparent" }}
                value=""
                onKeyDown={(e) => e.stopPropagation()}
              >
                <Button
                  color="primary"
                  style={{ fontWeight: 700 }}
                  onClick={() => {
                    setLoading(true)
                    handleShowMore(label)
                    setTimeout(() => {
                      setLoading(false)
                    }, 2000)
                  }}
                >
                  {t("SHOW_MORE")}
                </Button>
              </MenuItem>
            ) : null}

            <MenuItem
              disabled
              style={{
                background: "#bcb9b9",
                width: "100%",
                display: "flex",
                justifyContent: "end",
                height: "30px",
              }}
            >
              {dropdownData?.length + ` ${t("OF")} ` + totalDocs}
            </MenuItem>
          </>
        )}
      </Select>
      {error && (
        <FormHelperText
          error
          style={{ marginLeft: 14, marginRight: 14, marginTop: 4 }}
        >
          {t(helperText)}
        </FormHelperText>
      )}
    </FormControl>
  )
}
export { DropdownPagination }
export default DropdownPagination
